import React, { useEffect } from "react";
import { classnames, disableCopy } from "utils/general";

const ProblemStatement = ({ selectedProblem }) => {

  const isHtml = /<\/?[a-z][\s\S]*>/i.test(selectedProblem?.description);
  const textClass = "text-gold-hue leading-6";

  useEffect(() => {
    const questionElement = document.querySelector(".problem-container");
    questionElement.addEventListener('copy', disableCopy);
    return () => questionElement.removeEventListener('copy', disableCopy);
  }, []);

  return (
    <div className="problem-container min-w-[320px] w-[35%] bg-inherit px-4 mt-10 mb-1 overflow-y-auto">
      {selectedProblem ? (
        <div>
          <h2 className="problem-header pb-4 
            text-3xl text-white font-medium capitalize"
          >
            {selectedProblem?.title}
          </h2>
          {
            isHtml ? (
              <div
                className={classnames(textClass,'html')}
                dangerouslySetInnerHTML={{ __html: isHtml ? selectedProblem?.description: null }}
              />
            ) : (
              <pre className={textClass}>
                {selectedProblem?.description}
              </pre>
            )
          }
        </div>
      ) : (
        <div className="min-h-full min-w-full flex items-center justify-center">
          <div className="my-6 text-white flex items-center">
            <span className="text-xl mr-7">Loading Problem</span>
            <div className="dot-carousel relative top-2"></div>
          </div>
        </div> 
      )}
    </div>
  );
};

export default ProblemStatement;